/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {TwitterThreadLayout} from "../../layouts/TwitterThreadLayout";
import {TwitterThreadBlock, TwitterThreadAuthor, TwitterThreadOriginalUrl, TwitterThreadBlockFirst} from "../../components/TwitterThread";
export const meta = {
  url: "https://devsforgood.com/thread/from-rejection-to-success-the-9-steps-i-used-to-land-a-usd70k-raise-at-microsoft-after-applying-to-300-jobs",
  title: "From rejection to success: The 9 steps I used to land a $70k+ raise at Microsoft after applying to 300+ jobs",
  description: `I applied to 300+ jobs in 2013.Got rejected from all of them. `,
  image: "/covers/threads/from-rejection-to-success-the-9-steps-i-used-to-land-a-usd70k-raise-at-microsoft-after-applying-to-300-jobs.png",
  author: "Austin Belcak"
};
const MDXLayout = ({children}) => _jsx(TwitterThreadLayout, {
  meta: meta,
  children: children
});
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    em: "em",
    ul: "ul",
    li: "li",
    ol: "ol"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(TwitterThreadAuthor, {
      name: "Austin Belcak",
      username: "austinbelcak",
      avatarUrl: "/avatars/austinbelcak.png"
    }), "\n", _jsx(TwitterThreadOriginalUrl, {
      url: "https://twitter.com/austinbelcak/status/1502284757526327298"
    }), "\n", _jsxs(TwitterThreadBlockFirst, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "I applied to 300+ jobs in 2013."
      }), _jsx(_components.p, {
        children: "Got rejected from all of them."
      }), _jsx(_components.p, {
        children: "Two years later, I was in final rounds at Microsoft, Google, & Twitter."
      }), _jsx(_components.p, {
        children: "The result?"
      }), _jsx(_components.p, {
        children: "An offer from Microsoft with a $70k+ raise."
      }), _jsx(_components.p, {
        children: "Here’s a🧵 with the 9 steps I used to make it happen. ↓"
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsxs(_components.p, {
        children: ["1/  Understand Who Companies ", _jsx(_components.em, {
          children: "Really"
        }), " Hire"]
      }), _jsx(_components.p, {
        children: "I used to think the most qualified candidate got the job."
      }), _jsx(_components.p, {
        children: "That's not true."
      }), _jsx(_components.p, {
        children: "Companies don't hire the most qualified candidate."
      }), _jsx(_components.p, {
        children: "They hire the person they believe will deliver the most value."
      }), _jsx(_components.p, {
        children: "My new goal?"
      }), _jsx(_components.p, {
        children: "Be that person."
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "2/  Choose 15 Target Companies"
      }), _jsx(_components.p, {
        children: "To illustrate value, I had to narrow my focus."
      }), _jsx(_components.p, {
        children: "I stopped applying to random jobs online."
      }), _jsx(_components.p, {
        children: "Instead, I made a list of 15 target companies."
      }), _jsx(_components.p, {
        children: "Then I aimed to learn everything I could about:"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Their goals"
        }), "\n", _jsx(_components.li, {
          children: "Their challenges"
        }), "\n", _jsx(_components.li, {
          children: "Their major initiatives"
        }), "\n"]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "3/  Find 150 Prospects"
      }), _jsx(_components.p, {
        children: "I knew I needed a referral."
      }), _jsx(_components.p, {
        children: "An internal advocate would help me skip the line and maximize my value."
      }), _jsx(_components.p, {
        children: "So I made a list of 10 contacts at each company."
      }), _jsx(_components.p, {
        children: "I aimed for potential hiring managers and teammates."
      }), _jsx(_components.p, {
        children: "10 contacts * 15 companies = 150 total contacts."
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "4/  Start Making Contact"
      }), _jsx(_components.p, {
        children: "I didn't ask for a referral up front."
      }), _jsx(_components.p, {
        children: "I made my initial outreach about the other person:"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "I engaged with their content"
        }), "\n", _jsx(_components.li, {
          children: "Recognized career transitions"
        }), "\n", _jsx(_components.li, {
          children: "Asked for advice and followed up with results"
        }), "\n"]
      }), _jsx(_components.p, {
        children: "After a few touch points, I asked for a call."
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "5/  Identify Opportunities For Value"
      }), _jsx(_components.p, {
        children: "I used these calls to perform discovery."
      }), _jsx(_components.p, {
        children: "I'd ask my contacts about:"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Their journeys"
        }), "\n", _jsx(_components.li, {
          children: "The biggest challenge their team is facing"
        }), "\n", _jsx(_components.li, {
          children: "The six month goals for their team"
        }), "\n"]
      }), _jsx(_components.p, {
        children: "I'd look for any opportunity where I could illustrate tangible value."
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "6/  Research, Research, Research"
      }), _jsx(_components.p, {
        children: "With my potential opportunity in hand, I'd start researching."
      }), _jsx(_components.p, {
        children: "My favorite tactics were:"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Surveying customers / prospects"
        }), "\n", _jsx(_components.li, {
          children: "Performing competitive analyses"
        }), "\n", _jsx(_components.li, {
          children: "Gathering credible industry data"
        }), "\n"]
      }), _jsx(_components.p, {
        children: "Then I'd prepare my pitch."
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "7/  Crafting A Pitch Deck"
      }), _jsx(_components.p, {
        children: "I packaged my pitch in a short slide deck:"
      }), _jsx(_components.p, {
        children: "I introduced the problem / opportunity."
      }), _jsx(_components.p, {
        children: "I backed it up with industry data."
      }), _jsx(_components.p, {
        children: "I shared 2-3 ideas or solutions with an execution plan."
      }), _jsx(_components.p, {
        children: "Then I sent the deck to my contact and asked for a referral."
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "8/  Examples of Ideas"
      }), _jsx(_components.p, {
        children: "For Google, I created a personalized pitch strategy for a potential client."
      }), _jsx(_components.p, {
        children: "For Twitter, I shared 5 ideas for monetizing their existing audience."
      }), _jsx(_components.p, {
        children: "For Microsoft, I surveyed SMBs and turned the feedback into a strategy to help Microsoft Ads reach more SMBs."
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "9/  Referral + Value = Opportunities"
      }), _jsx(_components.p, {
        children: "Now I was walking into interviews with 2 things:"
      }), _jsxs(_components.ol, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "A referral from an internal advocate"
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "A clear, tangible illustration of my value that directly related to the company's goals"
          }), "\n"]
        }), "\n"]
      }), _jsx(_components.p, {
        children: "The focus was on that, not my non-traditional background."
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "10/  Landing The Offer"
      }), _jsx(_components.p, {
        children: "At the end, Microsoft extended an offer."
      }), _jsx(_components.p, {
        children: "I officially became a Partner Manager at Microsoft Ads."
      }), _jsx(_components.p, {
        children: "That job took my total comp from $70k / year → $130k / year."
      }), _jsx(_components.p, {
        children: "All without “traditional” experience and without applying online."
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "11/  Want More Advice Like This?"
      }), _jsx(_components.p, {
        children: "Give me a follow!"
      }), _jsx(_components.p, {
        children: "I share highly actionable threads on job searching and careers every Friday."
      }), _jsx(_components.p, {
        children: "Check out my podcast where I share job search tips in 10-15 minute episodes: cultivatedculture.com/podcast"
      }), _jsx(_components.p, {
        children: "Hopefully we'll see you back here next week 🤙"
      })]
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
